import { render, staticRenderFns } from "./Shareholders.vue?vue&type=template&id=b0620e2a&scoped=true&"
import script from "./Shareholders.vue?vue&type=script&lang=ts&"
export * from "./Shareholders.vue?vue&type=script&lang=ts&"
import style0 from "./Shareholders.vue?vue&type=style&index=0&id=b0620e2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0620e2a",
  null
  
)

export default component.exports